export const PAUSE_REASONS = [
    "Checked Out",
    "Team Meeting",
    "Lunch Break",
    "Tech Issue",
    "Client Wait",
    "Research Task",
    "Out Office",
    "Review Hold",
    "Different Project",
    "Other",
];

/** Shorter set for staff mobile pause flow */
export const STAFF_PAUSE_REASONS = [
    "Lunch break",
    "Guest waiting",
    "Need supplies",
    "Equipment issue",
    "Other",
];

export const PRIORITY_OPTIONS = [
    { value: "high", label: "High", className: "text-error border-error/40 bg-error/10" },
    { value: "medium", label: "Medium", className: "text-warning border-warning/40 bg-warning/10" },
    { value: "low", label: "Low", className: "text-info border-info/40 bg-info/10" },
];

export const REPEAT_OPTIONS = [
    { value: "none", label: "Does not repeat" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
];
